<script>
import { onMount } from 'svelte';
import { page } from '@inertiajs/inertia-svelte';
import { Toast } from 'bootstrap';

let errorToast;
let successToast;

onMount(() => {
  errorToast = new Toast(document.getElementById('error-toast'));
  successToast = new Toast(document.getElementById('success-toast'));
});

$: {
  if ($page.props.flash.error) {
    errorToast.show();
  }
}

$: {
  if ($page.props.flash.success) {
    successToast.show();
  }
}
</script>

<div aria-live="polite" aria-atomic="true" class="position-static">
  <div class="toast-container position-absolute top-0 end-0 p-3">
    <div id="error-toast" role="alert" aria-live="assertive" aria-atomic="true" class="toast bg-warning"
         data-bs-autohide="true" style="pointer-events: none">
      <div class="toast-header">
        <strong class="me-auto">Kļūda</strong>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Aizvērt"
                style="pointer-events: all"></button>
      </div>
      <div class="toast-body">
        {$page.props.flash.error}
      </div>
    </div>

    <div id="success-toast" role="alert" aria-live="assertive" aria-atomic="true" class="toast bg-success"
         data-bs-autohide="true" style="pointer-events: none">
      <div class="toast-header">
        <strong class="me-auto">Darbība izpildīta</strong>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Aizvērt"
                style="pointer-events: all"></button>
      </div>
      <div class="toast-body">
        {$page.props.flash.success}
      </div>
    </div>
  </div>
</div>

